// extracted by mini-css-extract-plugin
module.exports = {"container":"globalConfirmationModal_container__1FW-T","modal":"globalConfirmationModal_modal__3VwOc","btnContainer":"globalConfirmationModal_btnContainer__2Hghc"};